export const seo = {
    home: {
        title: 'ألياف الصلب ديناميكس | تعزيز الخرسانة عالي الأداء - تشورلو، تيكيرداغ',
        description: 'تقوم شركة ديناميكس لألياف الصلب بتصنيع ألياف الصلب ذات النهايات المعقوفة عالية الأداء لتعزيز الخرسانة في تشورلو، تيكيرداغ. حلول هندسية لبناء السدود والأنفاق والأرضيات الصناعية ومشاريع البنية التحتية في جميع أنحاء العالم.',
        keywords: 'ألياف الصلب، ألياف الصلب ذات النهايات المعقوفة، تعزيز الخرسانة، ديناميكس، ألياف الصلب تشورلو، بناء تيكيرداغ، بناء السدود، تعزيز الأنفاق، الأرضيات الصناعية، الخرسانة المرشوشة، UHPC، البنية التحتية، مواد البناء',
        schema: {
            webPage: {
                name: 'ألياف الصلب ديناميكس - الرئيسية',
                description: 'تعزيز ألياف الصلب عالي الأداء للهياكل الخرسانية'
            }
        }
    },
    product: {
        title: 'منتجات ألياف الصلب ذات النهايات المعقوفة | ديناميكس - تشورلو، تيكيرداغ',
        description: 'تعزيز ألياف الصلب ذات النهايات المعقوفة عالي الجودة للخرسانة. المواصفات الفنية: طول 30-60 مم، قطر 0.5-1.2 مم، قوة شد >1100 ميجا باسكال. متوافق مع ASTM A820. مثالي لبناء السدود والأنفاق والأرضيات الصناعية.',
        keywords: 'ألياف الصلب ذات النهايات المعقوفة، مواصفات ألياف الصلب، منتج تعزيز الخرسانة، ASTM A820، ألياف عالية الشد، ألياف الصلب المسحوبة على البارد، منتجات ديناميكس، مواد البناء تيكيرداغ'
    },
    applications: {
        title: 'تطبيقات ألياف الصلب | السدود، الأنفاق، الأرضيات الصناعية - ديناميكس',
        description: 'اكتشف تطبيقات ألياف الصلب من ديناميكس: بناء السدود، الأنفاق والأعمال تحت الأرض، الأرضيات الصناعية، العناصر مسبقة الصب، الأرصفة، بلاطات الأساس، خزانات المياه، والهياكل المقاومة للانفجار. حلول هندسية لمشاريع البنية التحتية.',
        keywords: 'تطبيقات ألياف الصلب، تعزيز بناء السدود، الخرسانة المرشوشة للأنفاق، خرسانة الأرضيات الصناعية، ألياف الخرسانة مسبقة الصب، تعزيز الأرصفة، ألياف بلاطة الأساس، تطبيقات البنية التحتية، حلول البناء',
        schema: {
            webPage: {
                name: 'تطبيقات ألياف الصلب',
                description: 'تطبيقات شاملة لألياف الصلب من ديناميكس في مشاريع البناء'
            }
        }
    },
    about: {
        title: 'عن ألياف الصلب ديناميكس | قصتنا، مهمتنا وقيمنا - تشورلو، تيكيرداغ',
        description: 'تعرف على ألياف الصلب ديناميكس: مصنع مبتكر لألياف الصلب في تشورلو، تيكيرداغ. مهمتنا هي توفير حلول ألياف الصلب عالية الجودة للهياكل الخرسانية المتينة. ملتزمون بالتميز في الجودة والابتكار والنزاهة والاستدامة.',
        keywords: 'عن ديناميكس، مصنع ألياف الصلب، شركة تشورلو تيكيرداغ، شركة مواد البناء، ابتكار ألياف الصلب، التصنيع عالي الجودة، البناء المستدام، الحلول الهندسية',
        schema: {
            webPage: {
                name: 'عن ألياف الصلب ديناميكس',
                description: 'معلومات الشركة، المهمة، الرؤية، والقيم الأساسية'
            }
        }
    },
    contact: {
        title: 'اتصل بألياف الصلب ديناميكس | تواصل معنا - تشورلو، تيكيرداغ',
        description: 'اتصل بشركة ديناميكس لألياف الصلب في تشورلو، تيكيرداغ. العنوان: شيخ سنان، شارع هوسمن كالفا رقم: 5/33، 59850 تشورلو/تيكيرداغ. الهاتف: +90 530 095 97 41. البريد الإلكتروني: info@dynamixsteelfiber.com. ساعات العمل: الاثنين-الجمعة 8 صباحًا - 6 مساءً، السبت 9 صباحًا - 2 مساءً.',
        keywords: 'اتصل بديناميكس، اتصال مورد ألياف الصلب، عنوان تشورلو تيكيرداغ، استفسار مواد البناء، عرض سعر ألياف الصلب، رقم هاتف ديناميكس، بريد إلكتروني ديناميكس'
    }
};
